import React, { useEffect, useState } from "react";
import api from "../api/axios";
import LedgerForm from "../components/forms/LedgerForm";

function Ledger() {
  const [ledgers, setLedgers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(""); // Fix 1: Track selected group separately
  const [loading, setLoading] = useState(true);
  const [selectedLedger, setSelectedLedger] = useState(null);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [search, setSearch] = useState("");

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
    ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
    : 0;

  // Fetch ledgers
  const fetchLedgers = async (pageNumber = 1, searchText = search, parent_group = 0) => {
    if (searchText && searchText.length < 3) return;

    setLoading(true);
    try {
      const res = await api.get(`/ledger-list?page=${pageNumber}&branch_id=${branch_id}&search=${searchText}&parent_group=${parent_group}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLedgers(res.data.data);
      setGroups(res.data.groups);
      setPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchLedgers(1, search, selectedGroup); // Fix 2: Included selectedGroup in debounce
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  // Handle edit click
  const handleEdit = (ledger) => {
    setSelectedLedger(ledger);
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  // After save/update refresh list
  const handleFormSubmit = () => {
    fetchLedgers(page, search, selectedGroup); // Fix 3: Keep filters active on form submit
    setSelectedLedger(null);
  };

  return (
    <>
      {/* Page Title */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Chart of Accounts</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item"><a href="#">Accounts</a></li>
                <li className="breadcrumb-item active">Chart of Accounts</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* Ledger List */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            {/* Header layout modified for pristine alignment */}
            <div className="card-header d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3">
              <h5 className="card-title mb-0">Account List</h5>

              {/* Grouped controls tightly together on the right side */}
              <div className="d-flex align-items-center gap-2 component-filters" style={{ minWidth: "45%" }}>
                <select
                  className="form-select"
                  value={selectedGroup}
                  onChange={(e) => {
                    const nextGroup = e.target.value;
                    setSelectedGroup(nextGroup); // Fix 4: Does not overwrite 'groups' list anymore
                    fetchLedgers(1, search, nextGroup);
                  }}
                >
                  <option value="">All Groups</option>
                  {groups.map((group) => (
                    <option key={group.id} value={group.id}>
                      {group.group_name}
                    </option>
                  ))}
                </select>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Name or Code..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            <div className="card-body">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="table-responsive ledger-scroll">
                  <table className="table table-bordered ledger-table">
                    <thead className="table-light sticky-top">
                      <tr>
                        <th>Sl.No.</th>
                        <th>Account Code</th>
                        <th>Account Name</th>
                        <th>Parent Head</th>
                        <th className="text-end">Current Balance</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody className="ledger-table-body">
                      {ledgers.length > 0 ? (
                        ledgers.map((ledger, index) => (
                          <tr key={ledger.id}>
                            <td>{index + 1}</td>
                            <td>{ledger.ledger_code}</td>
                            <td>{ledger.ledger_name}</td>
                            <td>{ledger.group.group_name}</td>
                            <td className="text-end">{parseFloat(ledger.current_balance).toFixed(2)}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-warning"
                                onClick={() => handleEdit(ledger)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No ledgers found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => fetchLedgers(page - 1, search, selectedGroup)}
                  disabled={page <= 1}
                >
                  Prev
                </button>
                <span>
                  Page {page} of {lastPage}
                </span>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => fetchLedgers(page + 1, search, selectedGroup)}
                  disabled={page >= lastPage}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">
                {selectedLedger ? "Update Account" : "Add New Account"}
              </h4>
            </div>
            <div className="card-body">
              <LedgerForm
                ledger={selectedLedger}
                onSuccess={handleFormSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Ledger;